/** Expenses API calls (typed). */

import { apiDelete, apiGet, apiPatch, apiPost, type PaginatedResponse, type QueryParams } from "@/lib/api-client";
import type { ApiExpense } from "./expenses.adapter";

export interface ExpensesListParams {
  page?: number;
  limit?: number;
  search?: string;
  category?: string;
  recurrent?: boolean;
  archived?: boolean;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export const expensesApi = {
  list: (params: ExpensesListParams = {}) =>
    apiGet<PaginatedResponse<ApiExpense>>("/expenses", params as QueryParams),
  create: (body: Record<string, unknown>) => apiPost<ApiExpense>("/expenses", body),
  update: (id: string, body: Record<string, unknown>) => apiPatch<ApiExpense>(`/expenses/${id}`, body),
  archive: (id: string) => apiDelete<ApiExpense>(`/expenses/${id}`),
  restore: (id: string) => apiPost<ApiExpense>(`/expenses/${id}/restore`),
};
